import { Button, styled } from '@mui/material';

// Secondary action button for the admin pages (Cancel, pagination).
// Reuses the shadcn "outline" button tokens (bg / text / border + hover) via the
// same CSS variables defined in index.css; size and spacing are left to each call site.
const SecondaryButton = styled(Button)(() => ({
  backgroundColor: 'hsl(var(--background))',
  color: 'hsl(var(--foreground))',
  border: '1px solid hsl(var(--input))',
  fontFamily: 'inherit',
  textTransform: 'none',
  '&:hover': {
    backgroundColor: 'hsl(var(--accent))',
    color: 'hsl(var(--accent-foreground))',
    borderColor: 'hsl(var(--input))',
  },
})) as typeof Button;

export default SecondaryButton;
